import { render } from "./tagsParameters.vue?vue&type=template&id=371f0b85&scoped=true"
import script from "./tagsParameters.vue?vue&type=script&lang=js"
export * from "./tagsParameters.vue?vue&type=script&lang=js"

import "./tagsParameters.vue?vue&type=style&index=0&id=371f0b85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371f0b85"]])

export default __exports__